/* eslint-disable quotes */

// ref: https://github.com/missive/emoji-mart/blob/main/packages/emoji-mart-data/i18n/en.json

export default {
  search: 'Search',
  search_no_results_1: 'Oh no!',
  search_no_results_2: 'That emoji couldn’t be found',
  pick: 'Pick an emoji…',
  add_custom: 'Add custom emoji',

  categories_activity: 'Activity',
  categories_custom: 'Custom',
  categories_flags: 'Flags',
  categories_foods: 'Food & Drink',
  categories_frequent: 'Frequently used',
  categories_nature: 'Animals & Nature',
  categories_objects: 'Objects',
  categories_people: 'Smileys & People',
  categories_places: 'Travel & Places',
  categories_search: 'Search Results',
  categories_symbols: 'Symbols',

  skins_choose: 'Choose default skin tone',
  skins_1: 'Default',
  skins_2: 'Light',
  skins_3: 'Medium-Light',
  skins_4: 'Medium',
  skins_5: 'Medium-Dark',
  skins_6: 'Dark',
};
